import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  console.log("Footer Inner Height:", window.innerHeight);

  return (
    <Container className='grad-bg d-flex justity-content-end mt-4'>
      <Row className='mt-3 pt-3'>
        <Col lg={3}>
          <h4>Flywheel Gallery</h4>
          <ul>
            <li>
              223 Ash Street <br></br>Piermont Landing<br></br> Piermont, NY,
              10968
            </li>
          </ul>
        </Col>
        <Col lg={3}>
          <h4>Hours</h4>
          <ul>
            <li>Thursday 1:00 PM to 6 PM</li>
            <li>Friday 12:00 PM to 8:00 PM</li>{" "}
            <li>Saturday 12:00 PM to 8:00 PM</li>{" "}
            <li>
              Sunday 1:00 PM to 6:00 PM <br></br>By Appointment Anytime
              <br></br>Please Call (845) 365-6411
            </li>{" "}
          </ul>
        </Col>
        <Col lg={3}>
          <h4>Board</h4>
          <ul>
            <li>Harry Martin, President</li>

            <li>Michael Scowden, Vice President</li>

            <li>Julie Scholz, Vice President</li>

            <li>Elaine Greene, Secretary</li>

            <li>Ron Wohlgemuth, Vice President Emeritus</li>
          </ul>
        </Col>
        <Col lg={3}>
          <h4>Social</h4>
          <ul>
            <li>Facebook</li> <li>Instagram</li> <li>YouTube</li>{" "}
          </ul>
        </Col>
        <Col lg={12} className='slideUp'>
          <p className='text-center image-title'>
            {" "}
            Copyright 2027 Piermont Flywheel Gallery All Rights Reserved -
            Artworks are owned by individual artists who retain the full
            copyrights to their works and images.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
